import {
    SITE_HI_SENSE_STATS_QUERY_GRAPH_LOADING,
    SAVE_SITE_HI_SENSE_STATS_QUERY_GRAPH
} from '../../constants/graphConstants/hiSenseGraphConstants';

/**
 * Reducer function for managing site hiSenese stats query graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const siteHiSenseStatsQueryGraphReducer = (state = {
    loading: false, 
    hiSense : [],
    yAxisLabels: [],
    apCount : [],
    qoeActive : [],
    apiError: null,
}, action) => {
	switch (action.type) {
		case SAVE_SITE_HI_SENSE_STATS_QUERY_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case SITE_HI_SENSE_STATS_QUERY_GRAPH_LOADING:
            return { 
                ...state,
                hiSenseGraph : [],
                yAxisLabels: [],
                apCount : [],
                qoeActive : [],
                apiError: null,
                loading: action.payload, 
            };
		default:
			return state;
	}
};